import { ConnectedPosition } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { NavBarItem } from '@shared/model/nav-bar-item';
import { LayoutService } from '@shared/services/layout.service';
import { BaseComponent } from '../base-component/base.component';
import { debounceTime, takeUntil } from 'rxjs/operators';
// import { RoutesUtil } from '@shared-features/utils/routes.util';
import { combineLatest } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NavListService } from '@layout/services/nav-list.service';
import { UserRole } from '@shared/enums/user-role.enum';
import { AnnouncementDialogComponent } from '../announcement-dialog/announcement-dialog.component';
import { ConfigConstant } from '@shared/constants';
import { TourListDialogComponent } from '../tour-guide/tour-list-dialog/tour-list-dialog.component';

@Component({
  selector: 'app-help-center-menu',
  templateUrl: './help-center-menu.component.html',
  styleUrls: ['./help-center-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpCenterMenuComponent extends BaseComponent implements OnInit {
  userRole: UserRole[];
  navigationItems: NavBarItem[];
  sideMenuActive = false;
  toggleMenu = false;
  position: ConnectedPosition = {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  };
  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    public layoutService: LayoutService,
    private matDialogService: MatDialog,
    public navService: NavListService,
  ) {
    super();
    navService.action$.pipe(takeUntil(this.destroy$)).subscribe((action) => {
      if (action === 'announcement') {
        this.openAnnouncementDialog();
      }

      if (action === 'guidedTour') {
        this.openTourListDialog();
      }

      if (action === 'customerSupport') {
        window.open(ConfigConstant.CUSTOMER_SUPPORT_URL, '_blank', 'noopener');
      }
    });
  }

  ngOnInit() {
    this.userRole = this.authService.currentUser$.value.userRoles;
    this.layoutService.websiteDirection$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setupNavBarItems();
    });
  }


  openAnnouncementDialog(): void {
    this.matDialogService.open(AnnouncementDialogComponent, {
      width: '550px',
    });
  }

  openTourListDialog(): void {
    this.matDialogService.open(TourListDialogComponent, {
      width: '400px',
      position: {
        top: '50px',
        left: this.layoutService.websiteDirection$.value === 'rtl' ? '50px' : undefined,
        right: this.layoutService.websiteDirection$.value === 'ltr' ? '50px' : undefined,
      }
    });
  }

  private setupNavBarItems(): void {
    combineLatest([this.translateService.get(['avatarMenu'])])
      .pipe(takeUntil(this.destroy$), debounceTime(100))
      .subscribe(([translations]: any) => {
        const { avatarMenu } = translations;

        this.navigationItems = [
          {
            title: avatarMenu.CustomerSupport,
            // path: RoutesUtil.SupportAddTicket.url(),
            action: 'customerSupport',
            icon: 'headphone',
            isVisible: true,
          },
          {
            title: avatarMenu.GuidedTour,
            icon: 'signpost',
            action: 'guidedTour',
            isVisible: true,
          },
          {
            title: avatarMenu.Announcement,
            icon: 'bulk-star',
            action: 'announcement',
            isVisible: this.userRole.includes(UserRole.SuperAdmin || UserRole.Admin || UserRole.ControlTower),
          },
        ];
      });
  }
}
